<template>
	<span v-if="enableReEntryBtn" class="scan-rfid">
		<button class="better-mobile-btn" :class="{ 'is-scanning': isScanning, 'grey-background': rfid !== '' && !isScanning } " v-on:click="startScanning">
			<CheckIcon v-if="rfid !== '' && !isScanning"/>
			<HandIcon v-else/>
			{{ btnLabel }}
		</button>
	</span>
</template>

<script>
/*
	RFID is emitted as a Low to High 7 byte Hex string (14 chars) with the colons stripped.
 */

import HandIcon from "./icons_svg/HandIcon.vue";
import CheckIcon from "./icons_svg/CheckIcon.vue";

const DEFAULT_BTN_LABEL = 'SCAN RE-ENTRY';
const IS_SCANNING_BTN_LABEL = 'TAP RFID';

export default {
	name: 'ScanRFIDButton',
	components: {
		CheckIcon,
		HandIcon
	},
	props: {
	},
	data() {
		return {
			shouldEmit: false,
			isScanning: false,
			rfid: '',
			btnLabel: DEFAULT_BTN_LABEL,
			enableReEntryBtn: process.env.VUE_APP_ENABLE_REENTRY === "true"
		}
	},
	methods: {
		// Resets the state after rfid read or error
		resetState() {
			this.isScanning = false;
			this.btnLabel = DEFAULT_BTN_LABEL;
		},
		async startScanning() {
			this.shouldEmit = true;

			try {
				// Make sure browser (only chrome on devices so far) supports NFC
				// If not, fake a barcode for testing
				if (!("NDEFReader" in window)) {
					alert("Entering fake RFID for test.\n\nIf you are using a scanner phone, contact Champion support.");
					/* For testing on desktop */
					this.isScanning = true;
					this.buttonText = this.isScanningText;
					//return;
					this.onRfidRead('rfid_test_' + Date.now());
					/* End for testing on desktop */
					return;
				}
				const ndef = new NDEFReader();

				// Start reading the tag
				this.isScanning = true;
				this.btnLabel = IS_SCANNING_BTN_LABEL;

				// Add failing listeners
				ndef.addEventListener("readingerror", () => {
					this.resetState();
					alert("Cannot read data from the RFID. Try again or return it to your Gate Supervisor.");
				});

				// Scanned logic happens here
				ndef.addEventListener("reading", ({message, serialNumber}) => {
					this.onRfidRead(serialNumber);
				});

				await ndef.scan();
			} catch (error) {
				this.resetState();
				alert("error" + error);
			}
		},
		// Called when an RFID is read successfully
		onRfidRead(rfid) {
			// Make sure we're active due to multiple scanRFID elements & webnfc
			if (!this.shouldEmit) {
				return;
			}
			// Strip colons
			rfid = rfid.replaceAll(':', '');
			this.rfid = rfid;
			this.$emit('scanned', rfid);
			this.shouldEmit = false;
			this.resetState();
		},
	},
}
</script>

<style scoped>
.scan-rfid .loading-message {
	animation: pulse 1.65s infinite linear;
}

.is-scanning {
	background-color: #ff8d3f !important;
}

.grey-background {
	background: #666 !important;
}
</style>